// Third party libraries
import * as $ from 'jquery';

export const closeModalPageChangedMixins = {
	created() {
		// the popstate event is nearly the last thing done in the process of navigating pages
		$(window).on('popstate', this.hideModal);
	},
	beforeDestroy() {
		$(window).off('popstate', this.hideModal);
	},
	methods: {
		hideModal() {
			$('.modal').modal('hide');
		}
	}
}